import { useEffect, useRef } from "react";
import { STICKERS } from "../../assets/media/stickers";
import TgSticker from "../../components/sticker/TgSticker";
import "./NotFound.scss";
import gsap from "gsap";

function NotFound() {
    const pageRef = useRef(null);

    useEffect(() => {
        pageRef.current && gsap.fromTo(pageRef.current,
            {opacity: 0, scale: 1.01, y: -10},
            {opacity: 1, scale: 1, y: 0, duration: .5, ease: "power2.out"}
        )
    }, []);

    return (
        <div className="not-found-wrapper" ref={pageRef}>
            <div className="sticker"><TgSticker src={STICKERS.duck_dont_know} /></div>
            <div className="text">
                <div className="title">Упс, тут ничего нет.</div>
                <div className="description">Страница, которую вы ищите, не найдена. Перейдите на главную страницу.</div>
            </div>
        </div>
    );
};

export default NotFound;